import { LogicContext } from '@/logic/main/types';
import { isXsellVariant } from '@/logic/main/utils';

export const getSearchBar = async (context: LogicContext) => {
  if (!isXsellVariant() || !context.searchBarComponent?.id) {
    return {
      updates: [],
    };
  }

  return {
    updates: [
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.${context.searchBarComponent.id}.properties`,
          value: {
            visible: true,
            numberOfAllSearchGames: context.numberOfAllSearchGames,
          },
        },
      },
    ],
  };
};
